import axios from "../../utils/axios";

export type TabQuestionsStateResponse = {
    isReadonly: boolean;
    readonlyReason: string;
}

export const getTabQuestionsState = (rfpId: string) => axios
    .get(`/api/v1/frontend/tenders/facility-manager/${ rfpId }/tab-questions-state`)
    .then((response: { data: { data: TabQuestionsStateResponse } }) => response.data.data)
